import Vue from 'vue'

import CreateProject from './project/CreateProject.vue'
import UpdateProject from './project/UpdateProject.vue'
import ShareProject from './project/ShareProject.vue'
import CopyDocuments from './project/CopyDocuments.vue'

import AddDocuments from './input/AddDocuments.vue'
import AddDocs from './input/AddDocs.vue'
import ImportFiles from './input/ImportFiles.vue'

import ChangeProfilePhoto from './account/ChangeProfilePhoto.vue'
import ChangePassword from './account/ChangePassword.vue'
import ChangeName from './account/ChangeName.vue'
import ChangeEmail from './account/ChangeEmail.vue'
import BillingActivity from './account/BillingActivity.vue'
import Terminate from './account/Terminate.vue'

import ForkDocument from './gallery/ForkDocument.vue'
import ForkMasterpiece from './gallery/ForkMasterpiece.vue'

import ReviewDetail from './ReviewDetail.vue'
import RequestDetail from './RequestDetail.vue'
import ReportIssue from './ReportIssue.vue'
import ReportIssueDoc from './ReportIssueDoc.vue'

import ModalError from './Error.vue'
import ModalExpired from './Expired.vue'
import ModalExpiredDocClip from './ExpiredDocClip.vue'
import ModalExpiredReviews from './ExpiredReviews.vue'


Vue.component('ModalCreateProject', CreateProject)
Vue.component('ModalUpdateProject', UpdateProject)
Vue.component('ModalShareProject', ShareProject)
Vue.component('ModalCopyDocuments', CopyDocuments)

Vue.component('ModalAddDocuments', AddDocuments)
Vue.component('ModalAddDocs', AddDocs)
Vue.component('ModalImportFiles', ImportFiles)

Vue.component('ModalChangeProfilePhoto', ChangeProfilePhoto)
Vue.component('ModalChangePassword', ChangePassword)
Vue.component('ModalChangeName', ChangeName)
Vue.component('ModalChangeEmail', ChangeEmail)
Vue.component('ModalBillingActivity', BillingActivity)
Vue.component('ModalTerminate', Terminate)

Vue.component('ModalForkDocument', ForkDocument)
Vue.component('ModalForkMasterpiece', ForkMasterpiece)

Vue.component('ModalReviewDetail', ReviewDetail)
Vue.component('ModalRequestDetail', RequestDetail)
Vue.component('ModalReportIssue', ReportIssue)
Vue.component('ModalReportIssueDoc', ReportIssueDoc)

Vue.component('ModalError', ModalError)
Vue.component('ModalExpired', ModalExpired)
Vue.component('ModalExpiredDocClip', ModalExpiredDocClip)
Vue.component('ModalExpiredReviews', ModalExpiredReviews)


// WEBPACK FOOTER //
// ./src/components/modal/index.js